import { createTheme } from "@mantine/core";

/**
 * Тема MetaTRIZ. Сейчас — минимальная: дефолтная цветовая палитра Mantine
 * + чуть скорректированные radius/fontFamily. Будем эволюционировать когда
 * появится brand-direction (цвета, лого, типографика).
 */
export const theme = createTheme({
  primaryColor: "indigo",
  defaultRadius: "md",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeight: "600",
  },
});
